import WindowView from 'view/window'

export default new WindowView({ el: window })
